import { Box, Button, Container, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
  fetchProjectToAccess,
  fetchUserProjectAccesses,
  saveAccessUserProjects,
} from "../features/userProjectAccess/accessUserProjectApi";
import { useEffect } from "react";
import AccessUserProjectTable from "../components/accessUserProjectTable/AccessUserProjectTable";
import {
  hasProjectAccessChanges,
  selectIsLoading,
  selectProjectToAccess,
  selectUserProjectAccess,
} from "../features/userProjectAccess/accessUserProjectSlice";

const UserProjectAccessPage = () => {
  const dispatch = useAppDispatch();
  const projectsToAccess = useAppSelector(selectProjectToAccess);
  const userProjectAccesses = useAppSelector(selectUserProjectAccess);
  const isProjectAccesChanged = useAppSelector(hasProjectAccessChanges);
  const isLoading = useAppSelector(selectIsLoading);
  const areButtonsDisabled = !isProjectAccesChanged || isLoading;

  useEffect(() => {
    dispatch(fetchUserProjectAccesses());
    dispatch(fetchProjectToAccess());
  }, [dispatch]);

  const handleCancel = () => {
    dispatch(fetchUserProjectAccesses());
    dispatch(fetchProjectToAccess());
  };

  const handleSave = () => {
    dispatch(saveAccessUserProjects());
  };
  return (
    <Container
      className="App"
      maxWidth="lg"
      sx={{
        px: 4,
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        sx={{
          textAlign: "left",
          mt: 4,
        }}
      >
        User Projects Access
      </Typography>
      <Box sx={{ mt: 2 }}>
        <AccessUserProjectTable
          availableProjects={projectsToAccess}
          userProjectAccesses={userProjectAccesses}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "end",
          mt: 2,
          gap: 2,
        }}
      >
        <Button
          variant="contained"
          disabled={areButtonsDisabled}
          onClick={handleSave}
        >
          Save
        </Button>
        <Button
          variant="outlined"
          disabled={areButtonsDisabled}
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </Box>
    </Container>
  );
};

export default UserProjectAccessPage;
